
export const profiles = [
  {
    id: 1,
    name: 'さやか',
    age: 23,
    image:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/bbb17eeadeb4ea3512ee135ca90717fd.jpeg',
    rating: 4.9,
    reviews: 128,
    tags: ['優しい', '明るい', '癒し系'],
    description: '笑顔が素敵で話しやすい雰囲気です'
  },
  {
    id: 2,
    name: 'あいり',
    age: 25,
    image:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/eb454b3f81d1c038d7c83a35be904d11.jpeg',
    rating: 4.8,
    reviews: 95,
    tags: ['大人っぽい', '上品', '知的'],
    description: '落ち着いた雰囲気で会話も楽しめます'
  },
  {
    id: 3,
    name: 'ゆい',
    age: 22,
    image:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/1b0e69182ce61e76202eebdd402c2049.jpeg',
    rating: 4.7,
    reviews: 112,
    tags: ['可愛い', '元気', 'フレンドリー'],
    description: '元気いっぱいで楽しい時間を過ごせます'
  },
  {
    id: 4,
    name: 'みお',
    age: 24,
    image:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/83c0e7b1ce669dfb4c6f9a9b0fe2ba53.jpeg',
    rating: 4.9,
    reviews: 143,
    tags: ['癒し系', '優しい', '聞き上手'],
    description: '優しく包み込むような雰囲気が魅力です'
  },
  {
    id: 5,
    name: 'りな',
    age: 21,
    image:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/80e075815d98f54223da35399682727c.jpeg',
    rating: 4.8,
    reviews: 87,
    tags: ['天然', '甘えん坊', '笑顔'],
    description: '天真爛漫な笑顔に癒されること間違いなし'
  },
  {
    id: 6,
    name: 'はるか',
    age: 26,
    image:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/23276aae9a8b2fbcc9d92c0511d7628b.jpeg',
    rating: 4.9,
    reviews: 156,
    tags: ['セクシー', '大人', '魅力的'],
    description: '大人の色気と優しさを兼ね備えた女性です'
  },
  {
    id: 7,
    name: 'まな',
    age: 23,
    image:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/22c4bb071e8ccbe8b16ebbab08e30d44.jpeg',
    rating: 4.7,
    reviews: 98,
    tags: ['小悪魔', '可愛い', 'おしゃれ'],
    description: '小悪魔的な魅力で虜にされます'
  },
  {
    id: 8,
    name: 'えみ',
    age: 24,
    image:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/7a7672f908f07f2ad5c33076900babc4.jpeg',
    rating: 4.8,
    reviews: 134,
    tags: ['知的', 'クール', '美人'],
    description: 'クールビューティーで知的な会話が魅力'
  },
  {
    id: 9,
    name: 'ここな',
    age: 22,
    image:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/6832d44be06ef774b84f6e5e4eb7cd1c.jpeg',
    rating: 4.6,
    reviews: 76,
    tags: ['ピュア', '清楚', '癒し'],
    description: '清楚で透明感のある癒し系女子です'
  },
  {
    id: 10,
    name: 'あかね',
    age: 25,
    image:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/bf57cecb3e6b4a8c6081276c4dfe4213.jpeg',
    rating: 4.9,
    reviews: 167,
    tags: ['情熱的', 'ゴージャス', '魅惑'],
    description: '情熱的で一緒にいると時間を忘れます'
  }
];

export const apps = [
  {
    id: 1,
    name: 'おすすめNO１',
    tagline: '理想の相手が見つかる',
    logoImage:
      'https://public.readdy.ai/ai/img_res/9a8b8eddc6491c46c2683ff8bc3d978e.jpg',
    logoBg: 'bg-rose-50',
    rating: 4.8,
    downloads: '120万+',
    satisfactionBadge: 'ユーザー満足度99%',
    recommendPoint: 'AIが相性を分析！マッチング成功率No.1',
    recommendImage:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/16a8b934c00a47e2c1875742e20e1b93.jpeg',
    features: [
      'AIマッチングで相性抜群の相手を紹介',
      'ビデオ通話で事前に雰囲気を確認',
      '24時間サポート体制で安心',
      '女性会員爆増中！'
    ],
    reviews: [
      {
        userName: 'ゆうた',
        age: 28,
        rating: 5,
        comment: 'このアプリのおかげで素敵な出会いがありました！マッチング精度が高くて驚きです。',
        reviewImage: 'https://readdy.ai/api/search-image?query=natural%20casual%20japanese%20woman%20friendly%20smile%20wearing%20simple%20t-shirt%20indoor%20home%20setting%20soft%20natural%20window%20light%20everyday%20lifestyle%20portrait%20photography%20realistic%20authentic&width=400&height=300&seq=yuuta28rev&orientation=landscape'
      },
      {
        userName: 'こうへい',
        age: 31,
        rating: 5,
        comment: '登録して1週間で理想の相手と出会えました。AIマッチングの精度がすごい！',
        reviewImage: 'https://readdy.ai/api/search-image?query=attractive%20japanese%20woman%20short%20hair%20cute%20smile%20wearing%20casual%20stylish%20outfit%20sitting%20cafe%20warm%20bokeh%20background%20portrait%20photography&width=400&height=300&seq=rev1img2&orientation=landscape'
      },
      {
        userName: 'だいき',
        age: 25,
        rating: 4,
        comment: 'ビデオ通話機能が便利。実際に会う前に雰囲気がわかるので安心です。',
        reviewImage: 'https://readdy.ai/api/search-image?query=friendly%20japanese%20woman%20natural%20makeup%20wearing%20casual%20sweater%20indoor%20cozy%20room%20setting%20warm%20daylight%20relaxed%20smile%20authentic%20lifestyle%20portrait%20photography%20realistic&width=400&height=300&seq=daiki25rev&orientation=landscape'
      },
      {
        userName: 'しょうた',
        age: 29,
        rating: 5,
        comment: 'サポートが丁寧で初心者でも安心して使えました。おすすめです！',
        reviewImage: 'https://readdy.ai/api/search-image?query=approachable%20japanese%20woman%20medium%20length%20hair%20gentle%20smile%20wearing%20comfortable%20cardigan%20indoor%20living%20room%20natural%20lighting%20everyday%20authentic%20portrait%20photography%20realistic&width=400&height=300&seq=shouta29rev&orientation=landscape'
      },
      {
        userName: 'なおき',
        age: 27,
        rating: 5,
        comment: '毎日たくさんのいいねが来て驚きました。本当に女性会員が多くて出会いやすいです！',
        reviewImage: 'https://readdy.ai/api/search-image?query=charming%20japanese%20woman%20bright%20smile%20long%20hair%20wearing%20summer%20dress%20outdoor%20natural%20light%20cheerful%20portrait%20photography%20realistic&width=400&height=300&seq=rev1img5&orientation=landscape'
      }
    ],
    storeUrl: 'https://cl1-ck.com/rida_00app_lovenavi01.html'
  },
  {
    id: 2,
    name: 'おすすめNO２',
    tagline: '今夜の特別な出会い',
    logoImage:
      'https://readdy.ai/api/search-image?query=number%20two%20ranking%20silver%20medal%20badge%20icon%20app%20logo%20design%20gradient%20silver%20and%20orange%20colors%20bold%20number%202%20minimalist%20flat%20design%20on%20white%20background%20professional%20app%20store%20icon%20style&width=120&height=120&seq=apprank2silver&orientation=squarish',
    logoBg: 'bg-orange-50',
    rating: 4.6,
    downloads: '85万+',
    satisfactionBadge: '利用者の96%がリピート',
    recommendPoint: '即日マッチ可能！スピード出会いNo.1',
    recommendImage:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/d3e04c2a6d3851de70cefec421e4d413.jpeg',
    features: [
      'GPS連動で近くの相手をすぐ発見',
      'リアルタイムチャットで即やり取り',
      '趣味・嗜好でフィルタリング可能',
      'プライバシー完全保護'
    ],
    reviews: [
      {
        userName: 'けんじ',
        age: 32,
        rating: 5,
        comment: '使いやすくて出会いの質が高い！毎週末の楽しみが増えました。おすすめです。',
        reviewImage: 'https://readdy.ai/api/search-image?query=sexy%20japanese%20woman%20dark%20hair%20mysterious%20look%20wearing%20black%20outfit%20night%20city%20background%20glamorous%20portrait%20photography%20realistic&width=400&height=300&seq=rev2img1&orientation=landscape'
      },
      {
        userName: 'りょう',
        age: 27,
        rating: 5,
        comment: 'GPS機能で近くにいる人がすぐわかるのが最高。当日でも会えるのが魅力。',
        reviewImage: 'https://readdy.ai/api/search-image?query=attractive%20japanese%20woman%20ponytail%20sporty%20casual%20style%20bright%20smile%20outdoor%20park%20sunlight%20portrait%20photography%20realistic&width=400&height=300&seq=rev2img2&orientation=landscape'
      },
      {
        userName: 'まさき',
        age: 34,
        rating: 4,
        comment: 'プライバシー保護がしっかりしていて安心。身バレの心配なく使えます。',
        reviewImage: 'https://readdy.ai/api/search-image?query=beautiful%20japanese%20woman%20sophisticated%20look%20wearing%20elegant%20blouse%20indoor%20warm%20lighting%20sensual%20expression%20portrait%20photography&width=400&height=300&seq=rev2img3&orientation=landscape'
      },
      {
        userName: 'ひろき',
        age: 26,
        rating: 5,
        comment: 'チャットのレスポンスが早くてストレスなし。すぐに仲良くなれました！',
        reviewImage: 'https://readdy.ai/api/search-image?query=cute%20japanese%20woman%20playful%20smile%20wearing%20pink%20outfit%20indoor%20cozy%20atmosphere%20soft%20bokeh%20background%20portrait%20photography%20realistic&width=400&height=300&seq=rev2img4&orientation=landscape'
      },
      {
        userName: 'とおる',
        age: 30,
        rating: 5,
        comment: '登録当日にマッチして翌日には会えました。スピード感が他のアプリと全然違います！',
        reviewImage: 'https://readdy.ai/api/search-image?query=casual%20japanese%20woman%20natural%20look%20wearing%20denim%20jacket%20indoor%20cafe%20setting%20soft%20afternoon%20light%20genuine%20smile%20everyday%20authentic%20portrait%20photography%20realistic&width=400&height=300&seq=tooru30rev&orientation=landscape'
      }
    ],
    storeUrl: 'https://cl1-ck.com/rida_00app_lovenavi02.html'
  },
  {
    id: 3,
    name: 'おすすめNO３',
    tagline: '甘い時間を共有しよう',
    logoImage:
      'https://readdy.ai/api/search-image?query=number%20three%20ranking%20bronze%20medal%20badge%20icon%20app%20logo%20design%20gradient%20bronze%20and%20pink%20colors%20bold%20number%203%20minimalist%20flat%20design%20on%20white%20background%20professional%20app%20store%20icon%20style&width=120&height=120&seq=apprank3bronze&orientation=squarish',
    logoBg: 'bg-pink-50',
    rating: 4.7,
    downloads: '95万+',
    satisfactionBadge: '女性ユーザー満足度98%',
    recommendPoint: '女性会員数No.1！出会える確率が段違い',
    recommendImage:
      'https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/b7cab5b952b50df63f9de2b8be91dd7a.jpeg',
    features: [
      '女性ユーザー多数で出会いやすい',
      'デートプラン提案機能付き',
      'メッセージ既読機能で安心',
      '初回無料ポイントプレゼント'
    ],
    reviews: [
      {
        userName: 'たくや',
        age: 26,
        rating: 5,
        comment: '女性の質が高くてびっくり！デートプラン提案機能が便利で、初デートも大成功でした。',
        reviewImage: 'https://readdy.ai/api/search-image?query=sweet%20japanese%20woman%20natural%20beauty%20wearing%20casual%20blouse%20indoor%20bright%20room%20setting%20soft%20daylight%20warm%20smile%20approachable%20authentic%20portrait%20photography%20realistic&width=400&height=300&seq=takuya26rev&orientation=landscape'
      },
      {
        userName: 'ゆうき',
        age: 30,
        rating: 5,
        comment: '無料ポイントだけでも十分出会えました。コスパ最強のアプリだと思います。',
        reviewImage: 'https://readdy.ai/api/search-image?query=cheerful%20japanese%20woman%20shoulder%20length%20hair%20wearing%20simple%20knit%20top%20indoor%20home%20environment%20natural%20window%20light%20friendly%20expression%20everyday%20lifestyle%20portrait%20photography%20realistic&width=400&height=300&seq=yuuki30rev&orientation=landscape'
      },
      {
        userName: 'そうた',
        age: 24,
        rating: 4,
        comment: 'デートプラン提案が秀逸。お店選びに困らなくなりました。',
        reviewImage: 'https://readdy.ai/api/search-image?query=beautiful%20japanese%20woman%20innocent%20look%20wearing%20white%20outfit%20soft%20pastel%20background%20gentle%20smile%20portrait%20photography%20realistic&width=400&height=300&seq=rev3img3&orientation=landscape'
      },
      {
        userName: 'かずき',
        age: 33,
        rating: 5,
        comment: '既読機能があるので相手の反応がわかりやすい。やり取りがスムーズです。',
        reviewImage: 'https://readdy.ai/api/search-image?query=relaxed%20japanese%20woman%20natural%20style%20wearing%20comfortable%20hoodie%20indoor%20casual%20setting%20soft%20lighting%20genuine%20smile%20everyday%20authentic%20portrait%20photography%20realistic&width=400&height=300&seq=kazuki33rev&orientation=landscape'
      },
      {
        userName: 'りょうた',
        age: 28,
        rating: 5,
        comment: '女性会員の数が圧倒的に多い！毎日新しい出会いがあって飽きません。最高です。',
        reviewImage: 'https://readdy.ai/api/search-image?query=charming%20japanese%20woman%20long%20straight%20hair%20wearing%20cozy%20knit%20sweater%20indoor%20warm%20cafe%20autumn%20mood%20soft%20lighting%20portrait%20photography%20realistic&width=400&height=300&seq=rev3img5&orientation=landscape'
      }
    ],
    storeUrl: 'https://cl1-ck.com/rida_00app_lovenavi03.html'
  }
];
